import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import * as config from '@config';
import { addMessage, MsgLevel } from '@features/messages/messagesSlice';
import { GetToken } from '../../utils/storage';

const initialState = {
    data: [],
    fetching: false,
    fetched: false,
    error: '',
};

// fetch ALL accommodations
export const fetchAccommodations = createAsyncThunk('accommodations/fetch', async (data, thunkAPI) => {
    const url = new URL(`${config.apiURL}/hotels`);
    try {
        const resp = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${GetToken()}`,
            },
        });
        return resp.data;
    } catch (error) {
        const msg = error.response?.data?.error || 'Something went wrong with fetchAccommodations';
        thunkAPI.dispatch(
            addMessage({
                type: MsgLevel.Error,
                content: msg,
            })
        );
        return thunkAPI.rejectWithValue(msg);
    }
});

const accommsSlice = createSlice({
    name: 'accommodations',
    initialState,
    reducers: {
        cleanupAccommodations: (state) => {
            console.log('cleanup accommodations');
            state = initialState;
            return state;
        },
    },
    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        builder
            .addCase(fetchAccommodations.pending, (state, action) => {
                state.fetching = true;
            })
            .addCase(fetchAccommodations.fulfilled, (state, action) => {
                const accomms = action.payload.hotels;
                state.fetched = true;
                state.fetching = false;
                state.data = accomms;
            })
            .addCase(fetchAccommodations.rejected, (state, action) => {
                state = { ...initialState };
                state.error = action.payload;
                console.log(action);
            });
    },
});

export const { cleanupAccommodations } = accommsSlice.actions;

export default accommsSlice.reducer;
